import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(private cookieService: CookieService, private router: Router) {}

  canActivate() {
    // Sesión única: sin session_id (login anterior a la sesión única) se vuelve a pasar por login
    if (!this.cookieService.check('auth_token') || !this.cookieService.check('session_id')) {
      this.router.navigate(['/login']);
      return false;
    } else {
      return true;
    }
  }
}
